import { BaseService } from "core/services";
import { CaseStatusRouteService } from "application/tracking-case/services";

class CaseStatusService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new CaseStatusRouteService());
	}
	
    async lookup(filter){
        const url = this.routeService.lookup(filter);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }
}

export default CaseStatusService;